import React,{useState} from "react";
import { Box, Button } from "@mui/material";
import { CircularProgress, Typography } from "@mui/material";
import { useQuery} from "@apollo/client";
import { setupManagementUrl } from "../../../config";
import Form from "./forms";
import DynamicTableForJson from "../../../data/DynamicTable/dynamicTableForJson";
import { RowingOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import Joyride from "react-joyride"; // Import Joyride

const base_url = setupManagementUrl.uri;

// Define tour steps for the Rights page
const rightsTourSteps = [
  {
    target: ".dynamic-table-header",
    content: "This is the Product Charges page, where you can manage Product Charges.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-search",
    content: "Use the search bar to find specific Product Charges by name or other criteria.",
    placement: "bottom",
  },
  {
    target: ".dynamic-table-add-button",
    content: "Click this button to add a new Product Charge.",
    placement: "right",
  },
  // {
  //   target: ".dynamic-table-grid",
  //   content: "This table displays all rights. You can view and manage them here.",
  //   placement: "top",
  // },
  {
    target: ".dynamic-table-actions",
    content: "Select actions to be able to Edit each Product Charge from this dropdown.",
    placement: "left",
  },
];
const ignoreFields = ["UpdateDate"];

const ProductChargesTable = ({}) => {
    const [runTour, setRunTour] = useState(false); // ▶️ State to control Joyride
  
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const productId= localStorage.getItem("ProductId")

   const navigate = useNavigate();

  const actions = {
    entity:localStorage.getItem("SelectedRight"),
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: true,
      permission: "ActivatePermission",
      modelName: "productChargeIds",
      inputObjectName: "bulkActivateDeactivateProductCharges",
    },
    AuditTrail: {
      key: "AuditTrail",
      button_name: "Audit Trail",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2], // Super Admin & Admin only
    },
    dataObject: {
      ignoreFields,
     objectName: "productChargesByProductId",
    parameters: {productId: parseInt(productId)},
    inputObjectName:"productcharge",
    },
    showMore:{
      search:false,
      min: 0,
      max:0
    }
  };
  
  return (
    <Box m="20px">
         <Joyride
                    steps={rightsTourSteps}
                    run={runTour}
                    continuous
                    showSkipButton
                    showProgress
                    styles={{
                      options: {
                        primaryColor: "#1976d2",
                        zIndex: 10000,
                      },
                    }}
                  />
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
       <Button onClick={ () => navigate(-1)} variant="contained">
            Back to Products
          </Button>
      <Button onClick={() => setRunTour(true)} variant="outlined" color="primary">
          Start Page Tour
        </Button>
      </Box>
      <>
      </>
      <DynamicTableForJson
        title="ProductCharges"
        subtitle="Manage ProductCharges"
        //columns={RightsColumns}
        FormComponent={Form}
        //query={allRights}
        base_url={base_url}
        actions={actions}
        tourSteps={rightsTourSteps} // Pass tour steps as prop
        />
    </Box>
  );
};

export default ProductChargesTable;
